import { Link } from "react-router-dom";

const cols = [
  { title: "Product", items: [["How It Works", "/how-it-works"], ["Pricing", "/pricing"], ["Sample Report", "/sample-report"], ["Demos", "/demos"], ["Get Found", "/get-found"], ["Agentic Ready", "/agentic-ready"], ["Autonomous Commerce", "/autonomous-commerce"]] },
  { title: "Learn", items: [["AI Commerce", "/ai-commerce"], ["Visibility vs Transactions", "/ai-visibility-vs-ai-transactions"], ["AEO / GEO", "/aeo-geo"], ["Machine Payments", "/machine-payments"], ["x402", "/x402"], ["Resources", "/resources"]] },
  { title: "Company", items: [["Security", "/security"], ["Contact", "/contact"], ["Login", "/login"], ["Blog", "/blog"]] },
  { title: "Legal", items: [["Privacy", "/privacy"], ["Terms", "/terms"], ["Refund Policy", "/refund-policy"], ["Sources", "/sources"]] },
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center">
                <span className="text-white font-heading font-bold text-lg">A</span>
              </div>
              <span className="font-heading font-bold text-lg text-white">Make My Business AI Ready <span className="text-slate-400 font-normal text-sm">(AgenticReady)</span></span>
            </div>
            <p className="text-sm text-slate-400 max-w-xs">Get Found. Get Chosen. Get Paid.</p>
            <p className="text-xs text-slate-500 mt-4">A product of Ajakaiye Innovation Holdings LLC.</p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-semibold text-white mb-3">{c.title}</h4>
              <ul className="space-y-2">
                {c.items.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-slate-400 hover:text-indigo-400 transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-slate-800 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Ajakaiye Innovation Holdings LLC. Statistics cited on this site reference published third-party scenarios (OpenAI, Stripe, Visa, Mastercard, Coinbase). We do not guarantee any third-party AI system will rank or recommend your business.</p>
        </div>
      </div>
    </footer>
  );
}
